module.exports = __webpack_public_path__ + "media/images/portugal_center/costanova-3775a6eea15a9762c5ebded8ae69ccf0.jpeg";